package com.vizio.redwolf.dms.model

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
sealed class PayNonceStatusResponse {
    @Serializable
    class Invalid(
        @SerialName("message") val message: String? = null,
        @SerialName("responseCode") val responseCode: String? = null
    ) : PayNonceStatusResponse()

    @Serializable
    @SerialName("device_pending")
    class Pending(
        @SerialName("id") val pin: String,
        val deviceId: String,
        val deviceInstanceId: String,
        val serialNumber: String,
        val friendlyName: String,
        val skipCreditCard: Boolean,
        val launchSource: String? = null,
        val xVizTraceId: String? = null
    ) : PayNonceStatusResponse() {
        val responseCode: String by lazy {
            @OptIn(kotlinx.serialization.ExperimentalSerializationApi::class)
            serializer().descriptor.serialName
        }
    }

    @Serializable
    @SerialName("device_registered")
    class Registered(
        @SerialName("id") val pin: String,
        val deviceId: String,
        val deviceInstanceId: String,
        val serialNumber: String,
        val friendlyName: String,
        val skipCreditCard: Boolean,
        val launchSource: String? = null,
        val xVizTraceId: String? = null
    ) : PayNonceStatusResponse() {
        val responseCode: String by lazy {
            @OptIn(kotlinx.serialization.ExperimentalSerializationApi::class)
            serializer().descriptor.serialName
        }
    }

    @Serializable
    @SerialName("device_does_not_exist")
    class NotExist(
        val message: String,
    ) : PayNonceStatusResponse() {
        val responseCode: String by lazy {
            @OptIn(kotlinx.serialization.ExperimentalSerializationApi::class)
            serializer().descriptor.serialName
        }
    }

    class Failed(val message: String) : PayNonceStatusResponse()
    class Error(val exception: Throwable) : PayNonceStatusResponse()
    class Timeout(val exception: Throwable) : PayNonceStatusResponse()

    fun <R> fold(
        onInvalid: (Invalid: Invalid) -> R,
        onPending: (Pending: Pending) -> R,
        onRegistered: (Registered: Registered) -> R,
        onNotExist: (NotExist: NotExist) -> R,
        onFailed: (Failed: Failed) -> R,
        onError: (Error: Error) -> R,
        onTimeout: (Timeout: Timeout) -> R
    ): R {
        return when (this) {
            is Invalid -> onInvalid(Invalid(this.message, this.responseCode))
            is Pending -> onPending(Pending(this.pin, this.deviceId, this.deviceInstanceId, this.serialNumber, this.friendlyName, this.skipCreditCard))
            is Registered -> onRegistered(Registered(this.pin, this.deviceId, this.deviceInstanceId, this.serialNumber, this.friendlyName, this.skipCreditCard))
            is NotExist -> onNotExist(NotExist(this.message))
            is Failed -> onFailed(Failed(this.message))
            is Error -> onError(Error(this.exception))
            is Timeout -> onTimeout(Timeout(this.exception))
        }
    }
}